import type { HeadersFunction, LoaderFunction, MetaFunction } from '@remix-run/node';

import StaticPage from '~/components/StaticPage';

import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';

import getStaticPageMetaData from '~/utils/getStaticPageMetaData';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

import { staticPageClientLoader } from '~/components/StaticPage/staticPageClientLoader';
import type { StaticPageLoaderData } from '../services/static_page';
import { staticPageLoader } from '../services/static_page';

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backward compatibility
export const headers: HeadersFunction = ({ actionHeaders, loaderHeaders, parentHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0', // no-cache
    'Cache-Tag': 'orchid-page',
  };
};

export const meta: MetaFunction<typeof staticPageLoader> = getStaticPageMetaData;
export const loader: LoaderFunction = async ({ request }) => {
  return staticPageLoader({
    request,
    pageRequestParams: {
      pathname: 'archive',
    },
  });
};

export const clientLoader = staticPageClientLoader;

const Archive = () => {
  const { page, site } = useTypedLoaderData<StaticPageLoaderData>();

  return <StaticPage page={page} site={site} />;
};

export const shouldRevalidate = shouldRevalidateLoaderData;

export default Archive;
